module.exports = __webpack_public_path__ + "img/xk.db5fd38e.svg";